import React from 'react'
import StatusBadge from '../../UI/statusBadge'

const StoreInfoCard = ({product}) => {
  return (
    <div className="card rounded-3">
          <div className="card-body">
            <div className="d-flex align-items-center flex-wrap gap-3">
              <div className="avatar">
              {product?.store?.logo &&  <img
              style={{aspectRatio:"1"}}
                  src={product?.store?.logo}
                  alt=""
                  className="img-50 rounded-circle media"
                />}
              </div>
              <div>
                <div className="d-flex align-items-center  flex-wrap  gap-1">
                  <h4>{product?.store?.name}</h4>{" "}
                  <StatusBadge status={product?.store?.is_active ?"active":"inActive"} />
                       <StatusBadge status={!product?.store?.is_closed ?"active":"inActive"} statusLabel={!product?.store?.is_closed ?"مفتوح":"مغلق"} />
                </div>
              </div>
            </div>
      
          </div>
        </div> 
  )
}

export default StoreInfoCard